export default "__VITE_ASSET__66903282__"